import { render, staticRenderFns } from "./my_expenses_claim.vue?vue&type=template&id=4636858e&scoped=true"
import script from "./my_expenses_claim.vue?vue&type=script&lang=js"
export * from "./my_expenses_claim.vue?vue&type=script&lang=js"
import style0 from "./my_expenses_claim.vue?vue&type=style&index=0&id=4636858e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4636858e",
  null
  
)

export default component.exports